export function eventColor(value) {
  const color = String(value || '').trim();
  return /^#?[0-9a-f]{3}([0-9a-f]{3})?$/i.test(color) ? '#' + color.replace(/^#/, '') : 'var(--primary-color)';
}
